import API_URL from '../config/api';

export interface ShopProduct {
  id: string;
  name: string;
  description: string;
  price: number;
  stock: number;
  image: string;
  image1: string;
  image2: string;
  image3: string;
  sku: string;
  category: string;
  unit: string;
  wholesale_price?: number;
  box_quantity?: number;
  tax_rate?: number;
  expiry_date?: string | null;
}

/** Resolve product image path — same rules as ProductList */
export function resolveShopImageUrl(src: string | null | undefined): string {
  if (!src || !String(src).trim()) return '';
  const s = String(src).trim();
  if (s.startsWith('http') || s.startsWith('data:') || s.startsWith('blob:')) return s;
  const base = API_URL.replace(/\/api\/?$/, '');
  return s.startsWith('/') ? `${base}${s}` : `${base}/${s}`;
}

/** Distinct product images in display order (image1 → image2 → image3, then legacy image) */
export function getProductImages(p: Pick<ShopProduct, 'image' | 'image1' | 'image2' | 'image3'>): string[] {
  const seen = new Set<string>();
  const urls: string[] = [];
  const slots = [p.image1, p.image2, p.image3, p.image];
  for (const raw of slots) {
    const resolved = resolveShopImageUrl(raw);
    if (resolved && !seen.has(resolved)) {
      seen.add(resolved);
      urls.push(resolved);
    }
  }
  return urls;
}
